import React from 'react';
import '../App.css';
import { Button } from './Button';
import './About.css';

function About() {
  return (
    <div className='hero-container'>
      <video src='http://jsxcode.com/reactapps/mainapps/videos/video-2.mp4' autoPlay loop muted />
      <h1>NEXT GENERATION TECHNOLOGY</h1>
        <p>See what makes up different.</p>
      <div className='hero-btns'>
        <Button
          className='btns'
          buttonStyle='btn--outline'
          buttonSize='btn--large'
        >
          GET STARTED
        </Button>
        <Button
          className='btns'
          buttonStyle='btn--primary'
          buttonSize='btn--large'
          onClick={console.log('hey')}
        >
          WATCH TRAILER <i className='far fa-play-circle' />
        </Button>
      </div>
    </div>
  );
}

export default About;